import { fmtOdds, fmtSigned, type BettingRecommendation, type MarketPlay } from '../lib/api';

function playLabel(p: MarketPlay, home: string, away: string): string {
  const team = p.side === 'home' ? home : p.side === 'away' ? away : p.side.toUpperCase();
  if (p.market === 'spread') return `${team} ${fmtSigned(p.line ?? 0, 1)}`;
  if (p.market === 'total') return `${p.side.toUpperCase()} ${p.line}`;
  return `${team} ML`;
}

/** Every market as a bar: model probability against the market's fair probability, edge colored. */
export function EdgeChart({ rec, home, away }: { rec: BettingRecommendation; home: string; away: string }) {
  const rows = [...rec.all_markets].sort((x, y) => y.edge_percent - x.edge_percent);
  return (
    <div className="card p-5">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-2">
        <p className="kicker">Model vs market</p>
        <div className="flex gap-4 text-[12px] text-muted">
          <span className="inline-flex items-center gap-1.5"><span className="h-2.5 w-2.5 rounded-sm bg-blue" />Kova</span>
          <span className="inline-flex items-center gap-1.5"><span className="h-2.5 w-2.5 rounded-sm bg-faint" />Market</span>
        </div>
      </div>
      <div className="flex flex-col gap-3">
        {rows.map((p) => {
          const model = Math.round(p.model_probability * 100), market = Math.round(p.market_fair_probability * 100);
          const good = p.edge_percent > 0;
          return (
            <div key={`${p.market}-${p.side}`}>
              <div className="mb-1 flex items-center justify-between gap-3 text-[13px]">
                <span className="truncate font-semibold">{playLabel(p, home, away)} <span className="mono-label ml-1">{fmtOdds(p.odds)}</span></span>
                <span className={`num shrink-0 ${good ? 'text-green' : 'text-muted'}`}>{fmtSigned(p.edge_percent, 1, '%')} edge</span>
              </div>
              <div className="relative h-2.5 w-full rounded-full bg-wash">
                <div className="absolute inset-y-0 left-0 rounded-full bg-faint/60" style={{ width: `${market}%` }} />
                <div className={`absolute inset-y-0 left-0 rounded-full ${good ? 'bg-blue' : 'bg-blue/45'}`} style={{ width: `${model}%` }} />
              </div>
              <div className="mt-1 flex justify-between text-[11px] text-muted"><span className="num">Kova {model}%</span><span className="num">Market {market}%</span></div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
